<script setup>
import { SmilePlus } from 'lucide-vue-next'
import EmojiPicker from '@/components/ui/EmojiPicker.vue'

const props = defineProps({
  reactions: { type: Array, default: () => [] },
  currentMemberId: { type: [Number, String], default: null },
  reverse: { type: Boolean, default: false },
})

const emit = defineEmits(['toggle'])

const isMine = (entry) => (entry.member_ids || []).includes(props.currentMemberId)
</script>

<template>
  <div class="flex flex-wrap items-center gap-1" :class="reverse ? 'flex-row-reverse' : ''">
    <button
      v-for="entry in reactions"
      :key="entry.emoji"
      type="button"
      class="inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-xs transition-colors"
      :class="isMine(entry)
        ? 'border-primary bg-primary/10 text-primary'
        : 'border-transparent bg-muted hover:border-border'"
      :title="(entry.names || []).join(', ')"
      @click="emit('toggle', entry.emoji)"
    >
      <span class="text-sm leading-none">{{ entry.emoji }}</span>
      <span class="font-medium">{{ (entry.member_ids || []).length }}</span>
    </button>
    <EmojiPicker @update:model-value="(e) => e && emit('toggle', e)">
      <button
        type="button"
        class="inline-flex h-6 w-7 items-center justify-center rounded-full bg-muted text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        title="Add reaction"
      >
        <SmilePlus class="size-3.5" />
      </button>
    </EmojiPicker>
  </div>
</template>
